var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1507 12.144C15.229 12.048 15.3248 12 15.4379 12C15.5511 12 15.6468 12.048 15.7252 12.144L22.1357 20L15.7252 27.856C15.6468 27.952 15.5511 28 15.4379 28C15.3248 28 15.229 27.952 15.1507 27.856C15.0724 27.76 15.0332 27.6427 15.0332 27.504C15.0332 27.3653 15.0724 27.248 15.1507 27.152L20.9867 20L15.1507 12.848C15.0724 12.752 15.0332 12.6347 15.0332 12.496C15.0332 12.3573 15.0724 12.24 15.1507 12.144Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNext);
export default __webpack_public_path__ + "static/media/button-next.2d53e41a5e017d8323120182b2d8ff35.svg";
export { ForwardRef as ReactComponent };